import LegalMarkdownPage from "../components/legal/LegalMarkdownPage";

export default function TermsOfService({ mustAcceptTos = false }) {
  return (
    <LegalMarkdownPage
      title="Terms of Service"
      documentPath="/legal/TERMS.md"
      mustAcceptTos={mustAcceptTos}
    />
  );
}
